const eventList = ['touchmove', 'wheel'] as const;

const BODY_FIXING_CLASS = 'lemon8-body-fixing';

const preventDefaultHandler = (event: Event): void => {
  event.preventDefault();
};

export const FixBodyUtil = {
  lastScrollY: 0,
  fix: () => {
    eventList.forEach((event) => {
      document.body.addEventListener(event, preventDefaultHandler, { passive: false });
    });
  },
  restore: () => {
    eventList.forEach((event) => {
      document.body.removeEventListener(event, preventDefaultHandler);
    });
  },
  partialFix: () => {
    if (document.body.classList.contains(BODY_FIXING_CLASS)) {
      return;
    }
    FixBodyUtil.lastScrollY = window.scrollY;
    document.body.style.top = `-${FixBodyUtil.lastScrollY}px`;
    document.body.classList.add(BODY_FIXING_CLASS);
  },
  partialRestore: () => {
    if (!document.body.classList.contains(BODY_FIXING_CLASS)) {
      return;
    }
    document.body.style.top = '';
    document.body.classList.remove(BODY_FIXING_CLASS);
    window.scrollTo({ top: FixBodyUtil.lastScrollY });
  },
};
